export default __webpack_public_path__ + "static/media/yashGarg.929ecc68.jpeg";